import { render, staticRenderFns } from "./CurrentDayStatistic.vue?vue&type=template&id=4734cf5d"
import script from "./CurrentDayStatistic.vue?vue&type=script&lang=js"
export * from "./CurrentDayStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports